/* istanbul ignore file */
import { getCenterCroppedSettings } from '@bingads-webui-campaign/image-experience-utils';
import _ from 'underscore';

const logoTypeLimit = 5;
export const duplicateImagesValidation = (data, elementType) => {
  let hasDuplicateError = false;
  let imageAsset = data.images;
  if (elementType === 'logo') {
    imageAsset = data.logos;
  }
  const filterImagesAsset = imageAsset.filter((imageData, index) => {
    const isDuplicate = imageAsset.findIndex(image => imageData.Url === image.Url) !== index;
    if (isDuplicate) {
      hasDuplicateError = true;
      return false;
    }
    return true;
  });
  return {
    hasDuplicateError,
    data: elementType === 'logo' ? { logos: filterImagesAsset } : { images: filterImagesAsset },
  };
};

export const imageMinSizeValidation = (data, minSizeConfig, elementType) => {
  let hasError = false;
  let imageAsset = data.images;
  if (elementType === 'logo') {
    imageAsset = data.logos;
  }

  const filterImagesAsset = imageAsset.filter((imageData) => {
    const width = _.get(imageData, 'width') || _.get(imageData, 'image.width') || _.get(imageData, 'CropWidth');
    const height = _.get(imageData, 'height') || _.get(imageData, 'image.height') || _.get(imageData, 'CropHeight');
    if (Array.isArray(minSizeConfig) && ((minSizeConfig[0] && (width < minSizeConfig[0])) || (minSizeConfig[1] && (height < minSizeConfig[1])))) {
      hasError = true;
      return false;
    }
    return true;
  });
  return {
    hasError,
    data: elementType === 'logo' ? { logos: filterImagesAsset } : { images: filterImagesAsset },
  };
};

export const processImageAssetPayload = ({ images, elementType, data }) => {
  if (elementType === 'logo') {
    // crop images to square and landscape
    let squareLogoCount = data.filter(logo => logo.ImageType === 'square').length;
    const logos = [];
    images.forEach((imageData) => {
      const squareSettings = getCenterCroppedSettings({
        SourceWidth: _.get(imageData, 'width') || _.get(imageData, 'image.width'),
        SourceHeight: _.get(imageData, 'height') || _.get(imageData, 'image.height'),
        SourceX: 0,
        SourceY: 0,
      }, 1);
      const landScapeSettings = getCenterCroppedSettings({
        SourceWidth: _.get(imageData, 'width') || _.get(imageData, 'image.width'),
        SourceHeight: _.get(imageData, 'height') || _.get(imageData, 'image.height'),
        SourceX: 0,
        SourceY: 0,
      }, 4);

      let cropSettings = squareSettings;
      let logoType = 'square';

      if ((squareLogoCount === logoTypeLimit) ||
        (landScapeSettings.SourceWidth * landScapeSettings.SourceHeight > squareSettings.SourceWidth * squareSettings.SourceHeight)) {
        logoType = 'landscape';
        cropSettings = landScapeSettings;
      } else {
        squareLogoCount += 1;
      }

      logos.push({
        Id: _.get(imageData, 'id') || _.get(imageData, 'image.id'),
        CropX: cropSettings.SourceX,
        CropY: cropSettings.SourceY,
        CropWidth: cropSettings.SourceWidth,
        CropHeight: cropSettings.SourceHeight,
        Name: null,
        Url: _.get(imageData, 'src') || _.get(imageData, 'image.src'),
        Type: 'ImageAsset',
        SubType: null,
        ImageType: logoType,
      });
    });

    return {
      logos: [
        ...data,
        ...logos,
      ],
    };
  }

  // we are not cropping images
  return {
    images: [
      ...data,
      ...images.map(imageData => ({
        Id: _.get(imageData, 'id') || _.get(imageData, 'image.id'),
        Url: _.get(imageData, 'src') || _.get(imageData, 'image.src'),
        CropX: 0,
        CropY: 0,
        CropWidth: _.get(imageData, 'width') || _.get(imageData, 'image.width'),
        CropHeight: _.get(imageData, 'height') || _.get(imageData, 'image.height'),
        Name: null,
        Type: 'ImageAsset',
        SubType: null,
      }))],
  };
};
